import axios from 'axios'
import {
  EMAIL_INVITE_FAIL,
  EMAIL_INVITE_REQUEST,
  EMAIL_INVITE_SUCCESS,
  EMAIL_PASSWORD_FAIL,
  EMAIL_PASSWORD_REQUEST,
  EMAIL_PASSWORD_SUCCESS,
  EMAIL_PROJECT_NOTIFICATION_FAIL,
  EMAIL_PROJECT_NOTIFICATION_REQUEST,
  EMAIL_PROJECT_NOTIFICATION_SUCCESS,
  EMAIL_SUPPORT_FAIL,
  EMAIL_SUPPORT_REQUEST,
  EMAIL_SUPPORT_SUCCESS,
  EMAIL_VALIDATION_FAIL,
  EMAIL_VALIDATION_REQUEST,
  EMAIL_VALIDATION_SUCCESS,
} from '../constants/emailConstants'

export const sendValidationEmail = (registration) => async (dispatch) => {
  try {
    dispatch({
      type: EMAIL_VALIDATION_REQUEST,
    })

    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    }

    const { data } = await axios.post(
      `/api/email/send-validation`,
      registration,
      config
    )

    dispatch({
      type: EMAIL_VALIDATION_SUCCESS,
      payload: data,
    })
  } catch (error) {
    console.log(error)
    dispatch({
      type: EMAIL_VALIDATION_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const sendPasswordEmail = (email) => async (dispatch) => {
  try {
    dispatch({
      type: EMAIL_PASSWORD_REQUEST,
    })

    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    }

    const { data } = await axios.post(
      `/api/email/password-reset`,
      { email },
      config
    )

    dispatch({
      type: EMAIL_PASSWORD_SUCCESS,
      payload: data,
    })
  } catch (error) {
    console.log(error)
    dispatch({
      type: EMAIL_PASSWORD_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const sendAdminInviteEmail = (user) => async (dispatch, getState) => {
  try {
    dispatch({
      type: EMAIL_INVITE_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.post(`/api/email/send-invite`, user, config)

    dispatch({
      type: EMAIL_INVITE_SUCCESS,
      payload: data,
    })
  } catch (error) {
    console.log(error)
    dispatch({
      type: EMAIL_INVITE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const sendCustomerInvite = (user) => async (dispatch, getState) => {
  try {
    dispatch({
      type: EMAIL_INVITE_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.post(
      `/api/email/send-customer-invite`,
      user,
      config
    )

    dispatch({
      type: EMAIL_INVITE_SUCCESS,
      payload: data,
    })
  } catch (error) {
    console.log(error)
    dispatch({
      type: EMAIL_INVITE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const sendCustomerProjectNotification =
  (project) => async (dispatch, getState) => {
    try {
      dispatch({
        type: EMAIL_PROJECT_NOTIFICATION_REQUEST,
      })

      const {
        userLogin: { userInfo },
      } = getState()

      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${userInfo.token}`,
        },
      }

      const { data } = await axios.post(
        `/api/email/send-customer-project-notification`,
        { project },
        config
      )

      dispatch({
        type: EMAIL_PROJECT_NOTIFICATION_SUCCESS,
        payload: data,
      })
    } catch (error) {
      console.log(error)
      dispatch({
        type: EMAIL_PROJECT_NOTIFICATION_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      })
    }
  }

export const sendDeliverablesAddedNotification =
  (project, fileLength) => async (dispatch, getState) => {
    try {
      const {
        userLogin: { userInfo },
      } = getState()

      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${userInfo.token}`,
        },
      }

      axios.post(
        `/api/email/send-add-deliverable-notification`,
        {
          project,
          fileLength,
          adminName: `${userInfo.firstName} ${userInfo.lastName}`,
        },
        config
      )
    } catch (error) {
      console.log(error)
      dispatch({
        type: EMAIL_VALIDATION_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      })
    }
  }

export const sendSupportRequest = (form) => async (dispatch) => {
  try {
    dispatch({
      type: EMAIL_SUPPORT_REQUEST,
    })

    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    }

    const { data } = await axios.post(
      `/api/email/send-support-request`,
      form,
      config
    )

    dispatch({
      type: EMAIL_SUPPORT_SUCCESS,
      payload: data,
    })
  } catch (error) {
    console.log(error)
    dispatch({
      type: EMAIL_SUPPORT_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}
